function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useState, useEffect } from 'react';
import { components } from 'react-select';
import Creatable from 'react-select/creatable';
import { useAsyncFn } from 'react-use';
import isEmpty from 'lodash/isEmpty';
import toLower from 'lodash/toLower';
import noop from 'lodash/noop';
import classnames from 'classnames';
import text from '../../../text';
import { client } from '../../../utilities/api';
import { getProjectName } from '../../../utilities/project';
import { isNull } from 'lodash/fp';
import Icon from '../../icon/Icon';
import { Badge } from 'react-bootstrap';
var Option = function(props) {
    var _props_data;
    return ((_props_data = props.data) === null || _props_data === void 0 ? void 0 : _props_data.__isNew__) ? /*#__PURE__*/ React.createElement("div", _object_spread({
        className: classnames('CreateOption center-content', {
            isFocused: props.isFocused
        })
    }, props.innerProps), /*#__PURE__*/ React.createElement(Icon, {
        icon: "plus"
    }), props.data.label) : /*#__PURE__*/ React.createElement(components.Option, props);
};
var IndicatorSeparator = function(_param) {
    var inputValue = _param.inputValue, props = _object_without_properties(_param, [
        "inputValue"
    ]);
    var existingOption = props.options.find(function(option) {
        return option.name && toLower(option.name) === toLower(inputValue) && !option.__isNew__;
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, inputValue && /*#__PURE__*/ React.createElement(Badge, {
        className: "inverted center-content mr-2",
        variant: existingOption ? 'warning' : 'info'
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "mr-1",
        icon: existingOption ? 'triangular-exclamation' : 'information'
    }), text(existingOption ? 'similar' : 'new')), "|");
};
// This one allows creation of new projects
var ProjectSelect = function(param) {
    var className = param.className, isAdmin = param.isAdmin, currentJob = param.currentJob, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? noop : _param_onChange, onBlur = param.onBlur, hasError = param.hasError, filterPredicate = param.filterPredicate, _param_isCreateOptionEnabled = param.isCreateOptionEnabled, isCreateOptionEnabled = _param_isCreateOptionEnabled === void 0 ? true : _param_isCreateOptionEnabled;
    var _useState = _sliced_to_array(useState(), 2), currentProject = _useState[0], setCurrentProject = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), options = _useState1[0], setOptions = _useState1[1];
    var _useState2 = _sliced_to_array(useState(), 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var _useAsyncFn = _sliced_to_array(useAsyncFn(/*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.listProjects({
                            isAdmin: isAdmin,
                            includeDemo: false,
                            inviteStatus: [
                                'accepted'
                            ]
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    setOptions(data.projects);
                    return [
                        2
                    ];
            }
        });
    })), 2), listProjectsState = _useAsyncFn[0], listProjects = _useAsyncFn[1];
    var _useAsyncFn1 = _sliced_to_array(useAsyncFn(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(inputName) {
            var project, _currentJob_project, data, data1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!isEmpty(currentJob) && isNull(currentJob.project.name))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            client.updateProjectName((_currentJob_project = currentJob.project) === null || _currentJob_project === void 0 ? void 0 : _currentJob_project.id, inputName)
                        ];
                    case 1:
                        data = _state.sent().data;
                        project = data.project;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            client.createProject(inputName)
                        ];
                    case 3:
                        data1 = _state.sent().data;
                        project = data1;
                        _state.label = 4;
                    case 4:
                        setOptions(function(previousOptions) {
                            return _to_consumable_array(previousOptions).concat([
                                project
                            ]);
                        });
                        setCurrentProject(project);
                        onChange(project);
                        return [
                            2
                        ];
                }
            });
        });
        return function(inputName) {
            return _ref.apply(this, arguments);
        };
    }()), 2), upsertProjectState = _useAsyncFn1[0], upsertProject = _useAsyncFn1[1];
    var handleCreateOption = upsertProject;
    useEffect(function() {
        if (!listProjectsState.loading && isEmpty(listProjectsState.value)) {
            listProjects();
        }
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Creatable, {
        inputValue: inputValue,
        onInputChange: setInputValue,
        components: {
            IndicatorSeparator: function(props) {
                return /*#__PURE__*/ React.createElement(IndicatorSeparator, _object_spread({
                    inputValue: inputValue
                }, props));
            },
            Option: Option
        },
        classNamePrefix: "Select",
        createOptionPosition: "first",
        className: classnames('Select', _define_property({
            hasError: hasError
        }, className, className)),
        onBlur: onBlur,
        defaultValue: currentJob === null || currentJob === void 0 ? void 0 : currentJob.project,
        isClearable: true,
        getOptionValue: function(item) {
            return item.id;
        },
        getOptionLabel: function(item) {
            return item.name;
        },
        isDisabled: listProjectsState.loading || upsertProjectState.loading,
        isLoading: listProjectsState.loading || upsertProjectState.loading,
        placeholder: text('searchProject'),
        value: currentProject,
        options: filterPredicate ? options === null || options === void 0 ? void 0 : options.filter(filterPredicate) : options,
        onChange: function(option) {
            onChange(option);
            setCurrentProject(option);
        },
        onCreateOption: handleCreateOption,
        formatOptionLabel: function(item) {
            var _item_label;
            return (_item_label = item === null || item === void 0 ? void 0 : item.label) !== null && _item_label !== void 0 ? _item_label : getProjectName(item);
        },
        isValidNewOption: function() {
            return isCreateOptionEnabled;
        }
    }));
};
export default ProjectSelect;
